export default __webpack_public_path__ + "static/media/react-2.e68b35f4.svg";